import { Component, Inject, Injector, OnInit, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Citation } from 'src/app/models/analyst-output.model';
import { FLYOUT_DATA } from 'src/app/shared/flyout/flyout-container/flyout-data.token';
import { getRichPreviewComponent } from 'src/app/shared/utils/citation-preview.util';
import { parseCitationRoute } from './citation-route.util';

@Component({
  standalone: false,
  selector: 'app-citation-panel',
  templateUrl: './citation-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './citation-panel.component.scss',
})
export class CitationPanelComponent implements OnInit {
  @ViewChild('previewHost', { read: ViewContainerRef, static: true }) private previewHost!: ViewContainerRef;

  readonly hasRichPreview: boolean;
  readonly fullRecordPath: string;
  readonly fullRecordQueryParams: Record<string, string>;

  constructor(
    @Inject(FLYOUT_DATA) public readonly citation: Citation,
    private readonly injector: Injector,
  ) {
    this.hasRichPreview = !!getRichPreviewComponent(this.citation);
    const { path, queryParams } = parseCitationRoute(this.citation.route);
    this.fullRecordPath = path;
    this.fullRecordQueryParams = queryParams;
  }

  /** Mounts the reused detail-popup component for this citation's entity type, if any. Those
   * components expect the bare record id via FLYOUT_DATA (that's their existing contract, used
   * elsewhere for grid row clicks), while this panel itself was opened with the whole Citation - so
   * FLYOUT_DATA is re-scoped for the child the same way FlyoutContainerComponent.open() sets it up
   * for this panel in the first place. */
  ngOnInit(): void {
    const component = getRichPreviewComponent(this.citation);
    if (!component) {
      return;
    }
    const scopedInjector = Injector.create({
      providers: [{ provide: FLYOUT_DATA, useValue: this.citation.recordId }],
      parent: this.injector,
    });
    this.previewHost.createComponent(component, { injector: scopedInjector });
  }
}
